import type {
  MixpanelCartData,
  MixpanelProductData,
} from '../helpers/generateCartEventData'

export type MixpanelEventData = Record<
  string,
  | string
  | number
  | boolean
  | string[]
  | MixpanelCartData[]
  | MixpanelProductData[]
>

/**
 * Cleans event data for Mixpanel by:
 * 1. Removing undefined values
 * 2. Converting null values to 0
 * 3. Ensuring type safety
 */
export const cleanEventData = <T extends Record<string, unknown>>(
  eventData: T,
): MixpanelEventData =>
  Object.fromEntries(
    Object.entries(eventData)
      .filter(([_, value]) => value !== undefined)
      .map(([key, value]) => [key, value === null ? 0 : value]),
  ) as MixpanelEventData
